import * as type from '../../../actions/index.types'

const initialState = {
    listData: [],
    pagination: null,
    loading: false,

    details: null,
    detailsLoading: false,

    createLoading: false,
    updateLoading: false,
    finalizeLoading: false,
    deleteLoading: false,
    clearLoading: false,
    importLoading: false,
    autoMatchLoading: false,
    autoMatchResult: null,
    manualMatchLoading: false,
    unmatchLoading: false,
};

export function BRSReducer(state = initialState, action) {
    switch (action.type) {
        // List
        case type.GET_BRS_LIST:
            return { ...state, loading: true }
        case type.GET_BRS_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                listData: action.payload?.data || [],
                pagination: action.payload?.meta?.pagination || null,
            }
        case type.GET_BRS_LIST_FAILURE:
            return { ...state, loading: false }

        // Details
        case type.GET_BRS_DETAILS:
            return { ...state, detailsLoading: true, details: null }
        case type.GET_BRS_DETAILS_SUCCESS:
            return { ...state, detailsLoading: false, details: action.payload?.data || null }
        case type.GET_BRS_DETAILS_FAILURE:
            return { ...state, detailsLoading: false }

        // Create / Update / Finalize / Delete
        case type.CREATE_BRS: return { ...state, createLoading: true }
        case type.CREATE_BRS_SUCCESS:
        case type.CREATE_BRS_FAILURE: return { ...state, createLoading: false }

        case type.UPDATE_BRS: return { ...state, updateLoading: true }
        case type.UPDATE_BRS_SUCCESS:
        case type.UPDATE_BRS_FAILURE: return { ...state, updateLoading: false }

        case type.FINALIZE_BRS: return { ...state, finalizeLoading: true }
        case type.FINALIZE_BRS_SUCCESS:
        case type.FINALIZE_BRS_FAILURE: return { ...state, finalizeLoading: false }

        case type.DELETE_BRS: return { ...state, deleteLoading: true }
        case type.DELETE_BRS_SUCCESS:
        case type.DELETE_BRS_FAILURE: return { ...state, deleteLoading: false }

        case type.CLEAR_BRS_ENTRIES: return { ...state, clearLoading: true }
        case type.CLEAR_BRS_ENTRIES_SUCCESS:
        case type.CLEAR_BRS_ENTRIES_FAILURE: return { ...state, clearLoading: false }

        case type.IMPORT_BRS_STATEMENT: return { ...state, importLoading: true }
        case type.IMPORT_BRS_STATEMENT_SUCCESS:
        case type.IMPORT_BRS_STATEMENT_FAILURE: return { ...state, importLoading: false }

        case type.AUTO_MATCH_BRS: return { ...state, autoMatchLoading: true }
        case type.AUTO_MATCH_BRS_SUCCESS:
            return { ...state, autoMatchLoading: false, autoMatchResult: action.payload?.data || null }
        case type.AUTO_MATCH_BRS_FAILURE: return { ...state, autoMatchLoading: false }

        case type.MANUAL_MATCH_BRS: return { ...state, manualMatchLoading: true }
        case type.MANUAL_MATCH_BRS_SUCCESS:
        case type.MANUAL_MATCH_BRS_FAILURE: return { ...state, manualMatchLoading: false }

        case type.UNMATCH_BRS: return { ...state, unmatchLoading: true }
        case type.UNMATCH_BRS_SUCCESS:
        case type.UNMATCH_BRS_FAILURE: return { ...state, unmatchLoading: false }

        case type.CLEAR_BRS_STATE:
            return { ...initialState }

        default:
            return state
    }
}
